import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import NapsTableRow from './NapsTableRow';

const NapsTableBody = ({ data, loading }) => (
    <div className="tn-napsTable__body ui-table__body">
        {
            loading && (
                <div className="ui-centered-wrapper">
                    <Svg
                        iconName="spinner"
                        size="2XL"
                        className="ui-animation_spinnerAnimation"
                    />
                </div>
            )
        }
        {
            !data.length && !loading && (
                <div className="ui-errorMessage">
                    <Svg iconName="results" size="2XL" />
                    <div className="ui-errorMessage__text">
                        No Naps for today in the Racing Post database
                    </div>
                </div>
            )
        }
        {
            (!!data.length) && data.map(item => (
                <NapsTableRow key={item.key} {...item} />
            ))
        }
    </div>
);

NapsTableBody.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        order: PropTypes.number,
        time: PropTypes.string,
        crs: PropTypes.string,
        tipster: PropTypes.string,
        levelStakes: PropTypes.string,
        horseId: PropTypes.number,
        horseName: PropTypes.string,
        date: PropTypes.string,
        courseName: PropTypes.string,
        diffusionTime: PropTypes.string,
        raceId: PropTypes.number,
    })).isRequired,
    loading: PropTypes.bool.isRequired,
};

export default NapsTableBody;



// WEBPACK FOOTER //
// ./src/js/napsTable/NapsTableBody.js